export default "__VITE_ASSET__JDT$Djou__"